import React, { useEffect, useState } from "react";
import { REPORT_FILTER_ACTION_TYPE } from "../../../../redux/actions-type";
import { useDispatch, useSelector } from "react-redux";
import { useReportStudentListCustomHook } from "./utils/utils";
import DateRangeModal from "../../../../globalComponents/Modals/DateRangeModal/DateRangeModal";
import { useCustomHook } from "../../../../globalComponents/GlobalFunctions/globalFunctions";
import { IoMdArrowDropright } from "react-icons/io";
import moment from "moment";
import "moment/locale/az";
const StudentsList = () => {
  const [openCalendar, setOpenCalendar] = useState(false);
  const [date, setDate] = useState({});

  const { studentsCountAndTotalContractAmountStatus } = useSelector(
    (state) => state.reportDatas
  );

  const { studentsCountContractStatusSelectedOption } = useSelector(
    (state) => state.reportDateFilter
  );
  const { tuitionStatusData } = useCustomHook();
  const [activeDebtors, setActiveDebtors] = useState([]);

  const { getAllDataByDateRange, getAllDataByMonth, getAllDefaultData } =
    useReportStudentListCustomHook();

  useEffect(() => {
    getAllDefaultData();
  }, []);

  const data = [
    { key: 1, name: "Cari ay" },
    // { key: 3, name: "Son 3 ay" },
    // { key: 6, name: "Son 6 ay" },
    // { key: 12, name: "İllik" },
    { key: "", name: "Tarix seç" },
  ];

  const dispatch = useDispatch();

  const applyFilter = (startDate = "", endDate = "") => {
    getAllDataByDateRange(startDate, endDate);
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_STUDENTS_COUNT_CONTRACT_STATUS_CHOOSE_DATE_FILTER,
      payload: {
        studentsCountContractStatusChooseDate: { startDate, endDate },
      },
    });
    setDate({
      startDate,
      endDate,
    });
    setOpenCalendar(false);
  };

  const applyMonthFilter = (option) => {
    getAllDataByMonth(option.key);
    setOpenCalendar(false);
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_STUDENTS_COUNT_CONTRACT_STATUS_MONTH_FILTER,
      payload: { studentsCountContractStatusMonthFilter: option.key },
    });

    setDate({});
  };

  const selectOption = (option) => {
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_STUDENTS_COUNT_CONTRACT_STATUS_DATE_SELECTED_OPTION,
      payload: option,
    });
    if (option.name === "Tarix seç") {
      setOpenCalendar(!openCalendar);
    } else {
      applyMonthFilter(option);
    }
  };

  useEffect(() => {
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_STUDENTS_COUNT_CONTRACT_STATUS_DATE_SELECTED_OPTION,
      payload: {
        key: 1,
        name: "Cari ay",
      },
    });
    return () => {
      dispatch({
        type: REPORT_FILTER_ACTION_TYPE.GET_STUDENTS_COUNT_CONTRACT_STATUS_MONTH_FILTER,
        payload: { studentsCountContractStatusMonthFilter: "" },
      });
    };
  }, []);
  return (
    <div className="student-list-card">
      <h2 style={{ fontSize: "16px", color: "#202224", fontWeight: "700px" }}>
        Debitor borcları
      </h2>
      <div className="finance-date-filter">
        {data.map((item, index) => (
          <div
            key={index}
            onClick={() => selectOption(item)}
            className={`content-box ${
              studentsCountContractStatusSelectedOption.key === item.key
                ? "active"
                : ""
            }`}
          >
            {item.name}
          </div>
        ))}
      </div>
      {date.startDate && date.endDate && (
        <div
          style={{ textAlign: "center", marginTop: "10px", fontSize: "12px" }}
        >
          <span>{`${moment(date?.startDate)
            .locale("az")
            .format("DD MMMM YYYY")} - ${moment(date?.endDate)
            .locale("az")
            .format("DD MMMM YYYY")} `}</span>
        </div>
      )}

      <table className="status-list-cards" style={{ marginTop: "20px" }}>
        <thead>
          <tr>
            <th>Status</th>
            <th>Tələbə Sayı</th>
            <th>Məbləğ {"(AZN)"}</th>
          </tr>
        </thead>
        <tbody>
          {studentsCountAndTotalContractAmountStatus
            ?.filter(
              (item) =>
                item.status !== "graduate" &&
                item.status !== "freeze" &&
                item.status !== "stopped"
            )
            .map((group, i) => {
              const matchedStatus = tuitionStatusData.find(
                (item) => item.key === group.status
              );

              let debtorItem;

              if (group.status === "continue") {
                // debtorItem = studentsCountAndTotalContractAmountStatus.find(
                //   (item) => item.status === "debtor-continue"
                // );
              } else if (group.status === "graduate") {
                debtorItem = studentsCountAndTotalContractAmountStatus.find(
                  (item) => item.status === "debtor-graduate"
                );
              } else if (group.status === "stopped") {
                debtorItem = studentsCountAndTotalContractAmountStatus.find(
                  (item) => item.status === "debtor-stopped"
                );
              } else if (group.status === "freeze") {
                debtorItem = studentsCountAndTotalContractAmountStatus.find(
                  (item) => item.status === "debtor-freeze"
                );
              }

              const matchedDebtorStatus = tuitionStatusData.find(
                (item) => item.key === debtorItem?.status
              );

              const isActive = activeDebtors.includes(group.status);

              return (
                <tr key={i}>
                  {/* <IoMdArrowDropright
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      marginTop: "5px",
                      visibility: debtorItem ? "visible" : "hidden",
                      transform: isActive ? "rotate(90deg)" : "rotate(0deg)",
                    }}
                    onClick={() => {
                      setActiveDebtors((prev) =>
                        prev.includes(group.status)
                          ? prev.filter((status) => status !== group.status)
                          : [...prev, group.status]
                      );
                    }}
                  /> */}
                  <td style={{ color: "#979797" }}>
                    <p>{matchedStatus ? matchedStatus.name : group.status}</p>
                    {debtorItem && isActive && (
                      <p
                        style={{
                          borderTop: "1px dashed #979797",
                          marginTop: "2px",
                          paddingTop: "2px",
                        }}
                      >
                        {matchedDebtorStatus ? matchedDebtorStatus.name : ""}
                      </p>
                    )}
                  </td>
                  <td style={{ color: "#FF9000" }}>
                    <p> {group.studentCount}</p>
                    {debtorItem && isActive && (
                      <p
                        style={{
                          borderTop: "1px dashed #979797",
                          marginTop: "2px",
                          paddingTop: "2px",
                        }}
                      >
                        {debtorItem.studentCount}
                      </p>
                    )}
                  </td>
                  <td>
                    <p>{group.totalPaymentsSum}</p>
                    {debtorItem && isActive && (
                      <p
                        style={{
                          borderTop: "1px dashed #979797",
                          marginTop: "2px",
                          paddingTop: "2px",
                        }}
                      >
                        {debtorItem.totalPaymentsSum}
                      </p>
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      {openCalendar && (
        <DateRangeModal
          applyFilter={applyFilter}
          setOpenCalendar={setOpenCalendar}
        />
      )}
    </div>
  );
};

export default StudentsList;
